import React from "react";
import CheckIcon from "components/icons/CheckIcon";
import { EditIcon } from "../../../../common/library/Icons";
import CustomerModel from "models/CustomerModel";
import useCustomerStore from "store/customerStore";

import { sendOtp, verifyOtp } from "utils/otp";
import PhoneOtpForm from "../../../../common/components/library/Form/PhoneOtpForm";
import usePreferencesStore from "store/preferencesStore";
import { getCSSVariable } from "helpers/appearance";

const OTP_RESEND_TIMER_IN_SECONDS = 30;

// TODO: Default select country code as per IP address of the user
const INITIAL_SELECTED_COUNTRY = {
  phone_code: "91",
  code: "IN",
  name: "India",
};

const VerifiedBanner = (props) => {
  const customer = useCustomerStore((state) => state.customer?.data);
  const setCustomer = useCustomerStore((state) => state.setCustomer);

  const clearCustomer = () => {
    const _customer = new CustomerModel();
    setCustomer(_customer);
  };

  return (
    <div className="-ml-4 -mr-4 -mt-4 bg-[#EDF3FE] border border-[#E6E9FA] p-4 flex items-center gap-1 h-fit">
      <CheckIcon />
      <span className="text-sm leading-5 text-[#16191B] font-bold select-none">
        Phone is verified
      </span>
      <div
        className="text-sm leading-5 text-[#16191B] underline flex items-center cursor-pointer"
        onClick={clearCustomer}
      >
        <span>{customer.mobile}</span>
        <div className="cursor-pointer ml-1">
          <EditIcon />
        </div>
      </div>
    </div>
  );
};

const LoginForm = () => {
  const customer = useCustomerStore((state) => state.customer?.data);
  const preferences = usePreferencesStore((state) => state.preferences.data);

  const invertColor = getCSSVariable("primary-color-light");

  if (customer) {
    return <VerifiedBanner />;
  } else {
    return <PhoneOtpForm 
      sendOtp={sendOtp} 
      verifyOtp={verifyOtp} 
      otpResendTimer={OTP_RESEND_TIMER_IN_SECONDS} 
      initialCountry={INITIAL_SELECTED_COUNTRY}
      invertColor={invertColor}
      primaryColor={preferences.theme.brand_color}
      />;
  }
};

export default LoginForm;
